<template>
  <el-dialog
    class="refund-dialog"
    @close="closeDialog"
    title="广告主退款申请"
    :visible="true"
    width="30%"
    center
  >
    <el-form
      :inline="true"
      label-width="100px"
      ref="recharge"
      class="demo-form-inline"
    >
      <el-row>
        <el-col
          :span="24"
          class="only-show"
        >
          <span class="field">广告主ID：</span>
          <span>{{refundInfo.UserId}}</span>
        </el-col>
        <el-col
          :span="24"
          class="only-show"
        >
          <span class="field">公司名称：</span>
          <span>{{refundInfo.CompanyName}}</span>
        </el-col>
        <el-col
          :span="24"
          class="only-show"
        >
          <span class="field">充值余额：</span>
          <span>{{refundInfo.RechargeAmount}}</span>
        </el-col>
        <el-col
          :span="24"
          class="only-show"
        >
          <span class="field">返点余额：</span>
          <span>{{refundInfo.RebateAmount}}</span><span style="margin-left: 5px;font-size: 12px; color: #ff9800"> ( 退款后将清空返点金额 ) </span>
        </el-col>
        <el-col
          :span="24"
          class="only-show"
        >
          <span class="field">可退金额：</span>
          <span style="color: #ff9800">{{refundInfo.RechargeAmount}}</span>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="user">
            <span slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</span>
            <el-input
              v-model="remark"
              type="text"
              :maxlength="inputLength"
              placeholder="请输入（限10个汉字）"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="closeDialog"
        size="small"
      >取消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="confirmDialog"
      >确认退款</el-button>
    </span>
  </el-dialog>

</template>
<script>
import { RefundShow } from "api/advertiser";
import { StatusInfo } from "api/retStatus";

export default {
  data() {
    return {
      remark: "",
      inputLength: null
    };
  },
  props: {
    refundInfo: Object
  },
  mounted() {},
  watch: {
    remark(curVal, oldVal) {
      var newvalue = curVal.replace(/[^\x00-\xff]/g, "**");
      var length = newvalue.length;

      //当填写的字节数小于设置的字节数
      if (length * 1 <= 20 * 1) {
        return;
      }
      var limitDate = newvalue.substr(0, 20);
      var count = 0;
      var limitvalue = "";
      for (var i = 0; i < limitDate.length; i++) {
        var flat = limitDate.substr(i, 1);
        if (flat == "*") {
          count++;
        }
      }
      var size = 0;
      var istar = newvalue.substr(20 * 1 - 1, 1); //校验点是否为“×”

      //if 基点是×; 判断在基点内有×为偶数还是奇数
      if (count % 2 == 0) {
        //当为偶数时
        size = count / 2 + (20 * 1 - count);
        limitvalue = curVal.substr(0, size);
      } else {
        //当为奇数时
        size = (count - 1) / 2 + (20 * 1 - count);
        limitvalue = value.substr(0, size);
      }
      // alert(
      //   title +
      //     "最大输入" +
      //     byteLength +
      //     "个字节（相当于" +
      //     byteLength / 2 +
      //     "个汉字）！"
      // );
      this.remark = limitvalue;
       this.inputLength = size;
      return;
      // var l = curVal.length;
      // var n = l;
      // for (var i = 0; i < l; i++) {
      //   if (curVal.charCodeAt(i) < 0 || curVal.charCodeAt(i) > 255) n++;
      // }
      // console.log(n)
      // console.log(curVal.length)
      // if (n >= 20) {
      //   if(n != curVal.length) {
      //     this.remark = curVal.substr(0,11);
      //     this.inputLength = curVal.length;
      //   } else {
      //     this.remark = curVal.substr(0,21);
      //     this.inputLength = curVal.length;
      //   }
      // } else {
      //   this.inputLength = null;
      // }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    confirmDialog() {
      if (this.refundInfo.RechargeAmount - 0 === 0) {
        this.$message({
          message: "暂无可退金额！",
          type: "warning"
        });
        this.$emit("close");
        return false;
      }
      var data = {
        UserId: this.refundInfo.UserId,
        RebateAmount: this.refundInfo.RebateAmount,
        CompanyName: this.refundInfo.CompanyName,
        RechargeAmount: this.refundInfo.RechargeAmount,
        remark: this.remark
      };
      this.refundInfo.callback(data).then(res => {
        if (res.result > 0) {
          this.$message({
            message: "退款申请已提交，通过审核后将退款成功。",
            type: "success"
          });
          this.$emit("close");
        } else {
          this.$message({
            message: StatusInfo(res.result) || "未知错误",
            type: "warning"
          });
          this.$emit("close");
        }
        if (this.formline.remark.length > 10) {
          this.$message({
            message: "备注不能超过10个字符！",
            type: "warning"
          });
          return;
        }
        this.refundInfo.callback(data).then(res => {
          if (res.result > 0) {
            this.$message({
              message: "退款申请已提交，通过审核后将退款成功。",
              type: "success"
            });
            this.$emit("close");
          } else {
            this.$message({
              message: StatusInfo(res.result) || "未知错误",
              type: "warning"
            });
            this.$emit("close");
          }
        });
      });
    }
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";
.refund-dialog {
  .el-dialog--center {
    .el-dialog__body {
      padding: 0;
      .el-row {
        border-top: 1px dashed #ececec;
        padding: 20px 20px 0;
        .field {
          width: 100px;
          height: 40px;
          text-align: right;
          display: inline-block;
        }
        .el-form-item {
          margin-bottom: 10px;
        }
      }
      p {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
      }
    }
    .dialog-footer {
      .el-button {
        width: 94px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/customer-management/refund-dialog.vue